import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosAdmin } from '../../../utils/axiosUser';

export const initStateClubList = {
  clubList: { data: null, loading: false, error: null },
};

export const clubList = createAsyncThunk('user/clubList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosAdmin
    .get(`/club/list`, {
      params: data,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerClubList = {
  [clubList.pending]: (state) => {
    state.clubList.loading = true;
  },
  [clubList.fulfilled]: (state, action) => {
    state.clubList.loading = false;
    state.clubList.data = action.payload;
    state.clubList.error = null;
  },
  [clubList.rejected]: (state, action) => {
    state.clubList.data = null;
    state.clubList.loading = false;
    state.clubList.error = action.payload;
  },
};
